import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
  Link
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ThuisverpleegLogo from '../components/ThuisverpleegLogo.tsx';


const WachtwoordVergeten: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Vul je e-mailadres in');
      return;
    }

    try {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email })
  });

  setIsSubmitted(true);

  if (response.ok) {
    setMessage('Als dit e-mailadres in ons systeem staat, ontvang je binnenkort instructies om je wachtwoord te resetten.');
  } else {
    setMessage('Er ging iets mis. Probeer opnieuw.');
  }
  } catch (error) {
    setIsSubmitted(true);
    setMessage("Server fout.");
  }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '80vh',
        }}
      >
        <Card sx={{ mt: 3, width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ p: 4 }}>
            {/* Logo */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <ThuisverpleegLogo />
            </Box>

            {/* Title */}
            <Typography component="h1" variant="h5" align="center" gutterBottom>
              Wachtwoord Vergeten
            </Typography>
            
            <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
              Vul je e-mailadres in om instructies te ontvangen voor het resetten van je wachtwoord.
            </Typography>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="E-mailadres"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                margin="normal"
                variant="outlined"
                autoComplete="email"
                autoFocus
                disabled={isSubmitted}
              />

              {message && (
                <Alert 
                  severity={isSubmitted ? "info" : "error"} 
                  sx={{ mt: 2 }}
                >
                  {message}
                </Alert>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={isSubmitted}
                sx={{ mt: 3, py: 1.5 }}
              >
                Verzenden
              </Button>
            </form>

            {/* Back to login link */}
            <Box sx={{ textAlign: 'center', mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
              <Link
                component="button"
                variant="body2"
                onClick={handleBackToLogin}
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Terug naar inloggen
              </Link>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default WachtwoordVergeten;
